module.exports = __webpack_public_path__ + "img/pocitelj.300dc44b.jpg";